export enum IntegrationClient {
  Api = 'api',
  Notion = 'notion',
  Circle = 'circle',
  GitHub = 'github',
}
